var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"info"},_vm._l((_vm.infoList),function(item,index){return _c('li',{key:index},[_c('p',{staticClass:"vs"},[_vm._v(_vm._s(item.version)+" :")]),_c('p',{staticClass:"if"},[_vm._v(_vm._s(item.information))]),_c('p',{staticClass:"tm"},[_vm._v(_vm._s(item.time))]),_c('p')])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }